module.exports = __webpack_public_path__ + "img/hotline.55e4a40c.png";